import React from "react";
import { Typography, Button, Dialog, DialogContent, DialogActions, DialogTitle } from "@mui/material";

import DialogBoxTitle from "../CommonPopup/DialogBoxTitle";
import theme from "../theme";

interface DialogBoxMFAProps {
  open: boolean;
  onClose: () => void;
  message: string;
}

const createStyles = () => ({
  columnA: {
    width: "25%",
  },
  columnB: {
    width: "75%",
  },
  header: {
    color: theme.palette.primary.main,
    marginBottom: "10px",
  },
  rows: {
    marginBottom: "20px",
  },
  commentBox: {
    maxHeight: "200px",
    overflowY: "scroll",
  },
  dialogBox: {
    width: "380px",
  },
});

const DialogBoxMFA: React.FC<DialogBoxMFAProps> = (props) => {
  const classes = createStyles();

  return (
    <>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        maxWidth={"md"}
        aria-labelledby="form-dialog-title"
        sx={{ paper: classes.dialogBox }}
      >
        <DialogTitle>
          <DialogBoxTitle title="Verification Error" width={200} closeButton handleClose={props.onClose} />
        </DialogTitle>

        <DialogContent>
          <Typography variant="h6" sx={classes.header}>
            {props.message}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DialogBoxMFA;
